import React, { useState } from 'react';
import '../assets/css/CustomAccordian.css';

const CustomAccordian = ({ items }) => {
    const [openIndexes, setOpenIndexes] = useState([]);

    const toggleAccordion = (index) => {
        setOpenIndexes(prevState =>
            prevState.includes(index)
                ? prevState.filter(i => i !== index)
                : [...prevState, index]
        );
    };

    return (
        <div className="accordion" id="accordionExample">
            {items.map((item, index) => (
                <div className="accordion-item" key={index}>
                    <h2 className="accordion-header my-2 pb-2" id={`heading${index}`} style={{borderBottom: '1px solid #D4D6DD'}}>
                        <button
                            className={`accordion-button ${openIndexes.includes(index) ? '' : 'collapsed'}`}
                            type="button"
                            onClick={() => toggleAccordion(index)}
                            aria-expanded={openIndexes.includes(index) ? 'true' : 'false'}
                            aria-controls={`collapse${index}`}
                        >
                            {item.title}
                        </button>
                    </h2>
                    <div
                        id={`collapse${index}`}
                        className={`accordion-collapse collapse ${openIndexes.includes(index) ? 'show' : ''}`}
                        style={{ transition: 'height 0.3s ease' }}
                    >
                        <div className="accordion-body">
                            {item.content}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CustomAccordian;
